<template>
  <v-dialog
    v-model="show"
    width="450"
    @click:outside="onClickOutside"
    persistent
  >
    <v-card>
      <div class="header-icon-wrapper">
        <v-icon color="blue darken-2">{{ icon }}</v-icon>
      </div>
      <div v-if="title" class="wrapper-title">
        <h3>{{ title }}</h3>
      </div>
      <div v-if="text" class="wrapper-text">
        <v-card-text>{{ text }}</v-card-text>
      </div>
      <div v-if="subtext" class="wrapper-text">
        <v-card-text>{{ subtext }}</v-card-text>
      </div>
      <div class="wrapper-action">
        <v-row>
          <v-col v-if="secondaryBtn">
            <v-btn large color="secondary" @click="onSecondary" :disabled="dialogOkLoading" :loading="dialogCancelLoading"
              >{{ $t(secondaryBtnText) }}
            </v-btn>
          </v-col>
          <v-col>
            <v-btn large color="primary" @click="onPrimary" :disabled="dialogCancelLoading" :loading="dialogOkLoading"
              >{{ $t(primaryBtnText) }}
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import SimpleWarningDialog from "./mixin/SimpleWarningDialog";

export default {
  mixins: [SimpleWarningDialog]
};
</script>

<style lang="scss" scoped>
$primaryColor: #3fa2f7;

.header-icon-wrapper {
  text-align: center;
  padding-top: 20px;
  .v-icon {
    font-size: 5rem;
  }
}
.wrapper-title {
  text-align: center;
  margin-top: 1%;
  margin-bottom: 1%;
  color: $primaryColor;
}
.wrapper-text {
  text-align: center;
  color: $primaryColor;
}
.wrapper-action {
  text-align: center;
  padding: 20px;
  .v-btn {
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SimpleWarningDialog.vue